import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";
import React from "react";
import { Link } from "react-router-dom";
import Avatar from "shared/Avatar/Avatar";
import Badge from "shared/Badge/Badge";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Comment from "shared/Comment/Comment";
import NcImage from "shared/NcImage/NcImage";
import SocialsList from "shared/SocialsList/SocialsList";
import Textarea from "shared/Textarea/Textarea";
import { Helmet } from "react-helmet-async";
import { useLanguage } from '../../contexts/languageContext'

const BlogSingle = () => {
  const { language, toggleLanguage } = useLanguage(); // Access language state

  const renderHeader = () => {
    return (
      <>
        {language === 'kr' && (
          <header className="container rounded-xl">
            <div className="max-w-screen-md mx-auto space-y-5">
              <Badge href="##" color="red" name="aerospace" />
              <Badge href="##" color="yellow" name="themedpark" />
              <Badge href="##" color="green" name="entertainment" />
              <h1
                className=" text-neutral-900 font-semibold text-3xl md:text-4xl md:!leading-[120%] lg:text-4xl dark:text-neutral-100 max-w-4xl "
                title="Quiet ingenuity: 120,000 lunches and counting"
              >
                "////코스모게이트로 바꾸기
              </h1>
              <span className="block text-base text-neutral-500 md:text-lg dark:text-neutral-400 pb-1">
                나로에스티피는 2023년 2월 6일부터 다양한 항공우주 교육을 개발하고 진행하고 있습니다. 항공우주 산업 현업자들이 제공하는 양질의 교육 프로그램을 x년동안 대학교, 고등학교, 사이언스센터, 육군본부 등 여러 단체들과 참가자 및 학생들의 니즈에 맞춰 커리큘럼 디벨롭 및 수업을 진행합니다. 항공우주 교육의 선두주자로서 나로에스티피는 모두를 위한 항공우주 교육의 발전을 위해 한국을 시작으로 전 세계에 우리의 항공우주 교육 프로그램을 제공하려는 목표를 가지고 있습니다.
              </span>
              <span className="block text-base text-neutral-500 md:text-lg dark:text-neutral-400 pb-1">
                이론 교육과 실습 프로젝트를 아우르는 프로그램은 항공 분야 관련인들 뿐만아니라 어린이 (어린 학생들) 와, 일반 대중, 항공 우주 산업 지망의 엔지니어, 그리고 업 스킬을 위한 다양한 분야의 현직자들까지 항공우주의 입문과 산업 전반의 인사이트와 네트워킹 그리고 실제로 필요한 지식과 스킬들을 다룹니다.
              </span>
              <p>
                나로에스티피의 항공우주 교육 프로그램들에 대한 개요를 확인하실 수 있습니다. 더 자세한 문의는<a href="/#" target="_blank" rel="noopener noreferrer">
                  여기
                </a>{" "} 로 주세요.

              </p>

              <div className="w-full border-b border-neutral-100 dark:border-neutral-800"></div>
              <div className="flex flex-col items-baseline sm:flex-row sm:justify-between">
                <div className="nc-PostMeta2 flex items-center flex-wrap text-neutral-700 text-left dark:text-neutral-200 text-sm leading-none flex-shrink-0">
                  <Avatar
                    containerClassName="flex-shrink-0"
                    sizeClass="w-8 h-8 sm:h-11 sm:w-11 "
                  />
                  <div className="ml-3">
                    <div className="flex items-center">
                      <a className="block font-semibold" href="/">
                      NAROSTP Writer
                      </a>
                    </div>
                    <div className="text-xs mt-[6px]">
                      <span className="text-neutral-700 dark:text-neutral-300">
                        3월 25일, 2025
                      </span>
                      <span className="mx-2 font-semibold">·</span>
                      <span className="text-neutral-700 dark:text-neutral-300">
                        작성
                      </span>
                    </div>
                  </div>
                </div>
                <div className="mt-3 sm:mt-0 sm:ml-3">
                  <SocialsList />
                </div>
              </div>
            </div>
          </header>
        )}
        {language === 'en' && (
          <header className="container rounded-xl">
            <div className="max-w-screen-md mx-auto space-y-5">
              <Badge href="##" color="purple" name="blog" />
              <h1
                className=" text-neutral-900 font-semibold text-3xl md:text-4xl md:!leading-[120%] lg:text-4xl dark:text-neutral-100 max-w-4xl "
                title="Quiet ingenuity: 120,000 lunches and counting"
              >
                Aerospace Education Programs: Inspiring the Next Generation of Innovators and Explorers
              </h1>
              <span className="block text-base text-neutral-500 md:text-lg dark:text-neutral-400 pb-1">
                NaroSTP is committed to delivering dynamic and impactful aerospace education programs that cater to a wide range of audiences around the world, starting in Korea. We are the pioneer and by far the leader in the aerospace industry in Korea to develop and deliver quality learnings. From hands-on projects for aspiring engineers to exciting introductory activities for young children and the general public, our educational programs are designed to spark curiosity, foster skills, and provide real-world insights into the aerospace industry. Below is an overview of the diverse initiatives we offer, highlighting their content and target audiences. Contact us for more details!

              </span>
              <p>
                Also, check out           <a href="/#" target="_blank" rel="noopener noreferrer">
                  here
                </a>{" "} for the list of students and institutions we have worked with!

              </p>

              <div className="w-full border-b border-neutral-100 dark:border-neutral-800"></div>
              <div className="flex flex-col items-baseline sm:flex-row sm:justify-between">
                <div className="nc-PostMeta2 flex items-center flex-wrap text-neutral-700 text-left dark:text-neutral-200 text-sm leading-none flex-shrink-0">
                  <Avatar
                    containerClassName="flex-shrink-0"
                    sizeClass="w-8 h-8 sm:h-11 sm:w-11 "
                  />
                  <div className="ml-3">
                    <div className="flex items-center">
                      <a className="block font-semibold" href="/">
                        Fones Mimi
                      </a>
                    </div>
                    <div className="text-xs mt-[6px]">
                      <span className="text-neutral-700 dark:text-neutral-300">
                        May 20, 2021
                      </span>
                      <span className="mx-2 font-semibold">·</span>
                      <span className="text-neutral-700 dark:text-neutral-300">
                        6 min read
                      </span>
                    </div>
                  </div>
                </div>
                <div className="mt-3 sm:mt-0 sm:ml-3">
                  <SocialsList />
                </div>
              </div>
            </div>
          </header>
        )}
      </>
    );
  };

  const renderContent = () => {
    return (
      <>
        {language === 'kr' && (
          <div
            id="single-entry-content"
            className="prose dark:prose-invert prose-sm !max-w-screen-md sm:prose lg:prose-lg mx-auto dark:prose-dark"
          >
            <h3>
              <p>
                이론 수업과 실습 프로젝트: 큐브 위성 만들기
              </p>
            </h3>
            <p>
              나로에스티피의 주력 프로그램으로서 자체 R&D를 통해 만든 큐브 위상 제작 교육 과정입니다. 학생들과 전문가들이 큐브 위성을 설계, 구축 그리고 테스트 할 수 있도록 역량을 키우는데 중점을 두고 있습니다. 이 프로그램은 이론 수업과 실습형 프로젝트들을 함께 다루며 궤도 역학 및 위성 설계 원리, 우주 환경, 위성 하드웨어 구성 요소 개발 및 조립, 페이로드에 대한 이해를 돕습니다. 참가자들은 산업 수준의 전문 기술 지식, 도구와 장비들을 사용할 수 있는 기회를 통해 프로젝트 관리, 팀워크, 그리고 문제 해결에 대한 경험도 할 수 있습니다. 이 프로그램은 전문 기술과 지식 습득을 원하는 학부생들과 군인들에게 특히 큰 긍정적인 평가를 얻고 있습니다. (실제 사진, 미디어 링크 여기에)
            </p>

            <h3>인공위성 데이터 프로세싱 프로젝트: LRIT 데이터 처리하기</h3>
            <p>
              또 다른 핵심 프로그램으로 LRIT 데이터 처리에 관한 전문 워크숍이 있습니다. 실제 사업에서 LRIT 데이터 처리 프로세스와 스킬을 학습할 수 있도록 참가자들은 기본 C++, LRIT 데이터 디코딩, 암혹 해독 및 분석하는 기술을 배우고, 여러 다양한 오류 처리에 대한 이해와 실습을 합니다. 마지막으로 LRIT 데이터를 이미지로 시각화하며 교육 프로그램이 완료됩니다.  이 프로그램은 학생들에게 위성 기술, 지리공간 과학 분야의 경력에 필수적인 고급 데이터 분석 기술을 갖추도록 합니다(??). 프로그램은 KARI 와 같은 항공우주 산업 전문가들이 진행을 해주십니다..
            </p>

            <blockquote>
              <p>
                우주 산업에 꿈을 그려온 우리가 프로그램을 통해 꿈을 향해 나아가고 발전할 수 있었던 기회
                출처 : 제주의소리(http://www.jejusori.net)
              </p>
            </blockquote>

            <figure>
              <img
                src="https://i.pinimg.com/736x/12/9d/4f/129d4f77185d727a722b5f895ead2743.jpg"
                alt="nc blog"
                className="rounded-2xl"
              />
              <figcaption>
                -
              </figcaption>
            </figure>

            <h3>
              <p>
                엔지니어 학생들을 위한 항공우주 개론학 (101)
              </p>
            </h3>
            <p>
              항공우주로의 커리어를 시작하고 싶어 산업에 필요한 관련 지식과 스킬들은 학습 및 습득 하려는 기계공학 학부생들을 위해 준비된 프로그램입니다. 이 프로그램은 세가지의 기본 구조를 가지고 갑니다.
            </p>
            <ol>
              <li>항공 역학, 엔진 및 추진 시스템에 대한 이해</li>
              <li>
                항공우주 응용 분야를 위한 구조체 분석
              </li>
              <li>
                우주환경에 대한 지식과 테스트 이해와 계획
              </li>
            </ol>
            <p>
              이 과정은 기계 공학 기초를 가지고 있는 학부생들이 전문 항공우주 개념 사이의 격차를 해소할 수 있고, 후에 학생들이 항공우주 산업에서 추가 연구나 경력을 쌓을 수 있는 발판은 만들어줍니다. 현직 항공우주 연구원들과 교육자들이 제공하는 이 프로그램은 산업의 트렌드를 밀접하게 수용하고 있습니다.
            </p>

            <h3>공업 고등학교 학생들을 위한 항공우주 커리큘럼</h3>
            <p>
              한 학기 동안 진행되는 고등학교 커리큘럼은 학생들에게 흥미로운 항공우주 공학을 다룹니다.
            </p>
            <ol>
              <li>
                항공 역학 및 우주 탐사의 개론 (101)
              </li>
              <li>
                모형 로켓, 글라이더, 큐브 인공위성의 설계 및 제작
              </li>
              <li>
                우주환경에 대한 지식과 시험 계획
              </li>
              <li>
                교내 우주 관련 연구실 또는 실험실 (lab) 디자인, 설계와 설치 지침 컨설턴팅
              </li>
            </ol>
            <p>
              나로에스티피는 제주 한림공고와 함께 국내 최초로 고등학생을 위한 항공우주 공학 교과 과정을 개발하고 있습니다. 딱딱한 이론 학습을 넘어서 학생들에게 영감을 주고 도전하는 마음을 키워주기 위한 실습 위주로 구성되어 있고 학생들의 창의력, 비판적 사고, STEM에 대한 열정을 키울 수 있도록 하는 목표를 가지고 있습니다. 또한 이 항공우주 커리큘럼의 개발은 제주 지방 정부와 한국 교육부 등과 긴밀히 협력하고 있습니다.
            </p>

            <h3>현직 STEM 교육자들을 위한 항공우주 업스킬</h3>
            <p>
              새로운 항공우주 교육과정을 준비함에 있어 학생들의 교육을 담당 해주실 현직 교육자들을 위한 특별한 워크숍과 프로그램들도 준비를 했습니다. 새로운 지식의 파급 효과를 견고히 하기 위해서 나로에스티피는 현직 고등학교 교육자와 교사들을 위한 맞춤형 기술 향상 프로그램을 제공하는데, 다음과 같습니다.
            </p>
            <ol>
              <li>
                최신 항공우주 기술 및 교육 방법론에 대한 교육 제공
              </li>
              <li>
                항공우주 컨텐츠를 기존 커리큘럼에 통합하는 방법에 대한 가이던스와 컨설팅
              </li>
              <li>
                교육 기술 향상을 위한 실습 워크샵 제공
              </li>
              <li>
                산업의 트렌드를 볼 수 있고 경험할 수 있는 미국 플로리다의 케네디 우주 방문자 센터, 미국 휴스턴의 존슨 우주 센터, 항우연연 등 항공우주 회사 및 기관 견학 제공
              </li>
            </ol>
            <p>
              나로에스트피의 기술 향상에 대한 도전은 교육자와 교사가 학생들과 함께 효과적으로 새로운 지식의 습득할 수 있도록 교육 부문과의 파트너십을 통해 나로에스티피는 항공우주 교육의 범위와 영향력을 확대하고 있습니다. 또한, 산업 트렌드를 놓치지 않도록 KARI, 케네디 우주 방문자 센터 등 업계와 긴밀히 협력하고 있습니다.
            </p>

            <h3>어린이들을 위한 항공우주</h3>
            <p>
              나로에스티피의 가장 중요한 가치 중 하나는 “재미를 추구한다” 입니다. 항공우주 교육의 시작을 만들어가고 있는 이 시기를 중요하게 생각하는데 항공우주 과학은 저희는 기존의 딱딱하고 재미없는 과학 프로그램이라는 굴레에서 벗어나고자 합니다.
            </p>
            <ol>
              <li>
                스토리텔링을 통한 우주 그리고 우주 탐사에 대한 이해 돋음
              </li>
              <li>
                실험과 만들기 프로젝트들 : 종이 로켓과 큐브 위성 만들기
              </li>
              <li>
                산업 방문 : KARI, 대전 / Kennedy Space Center , Florida / Johnson Space Center in Houston
              </li>
            </ol>
            <p>
              어린이 친구들이 항공우주와 STEM 평생 배움의 첫 걸음이 즐거운 것을 기억이 되기를 목표하고 있습니다.
            </p>

            <h3>항공우주 산업 방문</h3>
            <p>
              나로에스티피가 준비하고 제공하는 다양한 교육 프로그램들은 기술과 지식의 습득과 학습에 포커스를 맞추고 있습니다. 교실을 넘어 저희는 산업의 현황을 직접 살펴 볼 수 있는 기회도  제공합니다.
            </p>
            <ol>
              <li>
                미국 케네디 우주 센터와 존슨 우주센터 방문
              </li>
              <li>
                한국의 항공우주 제조 및 연구 시설을 견학
              </li>
              <li>
                질의 시간
              </li>
            </ol>
            <p>
              나로에스티피는 최고의 끊임없는 지식 추구의 동기부여는 점수나 좋은 직장을 갖는다와 같은 당장의 목표들이 아니라 가슴을 두근거리게 하는 경험과 각자의 삶을 관통하는 “스토리”의 발견이라고 생각합니다. 그러한 관점에서 실제 산업에서 꿈을 꾸고 있는 다양한 사람들과 역사적인 사건들에 대한 견학은 참가자들에게 독특하고 비교할 수 없는 “학습” 기회를 제공한다고 믿습니다. 이론적 지식을 실제 응용 프로그램 및 업계 동향 모두 경험을 할 수 있는 프로그램입니다.
            </p>

            <h3>나로에스티피는 “모두를 위한” 항공우주 교육을 지향합니다. </h3>
            <ol>
              <li>학부생
              </li>
              <li>군부
              </li>
              <li>고등 교육자
              </li>
              <li>
                고등학교 학생들
              </li>
              <li>
                아이들들
              </li>
              <li>일반인</li>
            </ol>
            <p>
              등의 많은 그룹에게 맞춤 교육을 제공하고자 합니다. 더 이상 과학은 어렵거나 재미없는 것이 아니라 많은 사람들이 경험하고, 담론 할 수 있는 지식체계가 되었으면 합니다.
            </p>

            <h3>파트너십</h3>
            <p>
              항공우주 산업의 현직자 및 고경력 전문가들이 주도하여 참가자들에게 폭넓은 실무 지식, 노하우 그리고 경험과 인사이트를 제공합니다. 또한 KARI, 케네디 우주 센터와 존슨 우주 센터와 같은 기관과의 파트너십을 통해 견학, 워크숍, 강의 등 여러가지 공동 프로젝트를 진행합니다. 마지막으로 지방자치단체, 제주 로컬 정부, 학교와 교육부등과 긴밀히 협력하고 있습니다.
            </p>


            <h3>앞으로의 계획</h3>
            <p>
              나로에스티피는 항공 우주 교육 확장을 위해 교육과 정부 기관, 업계 리더와의 협력을 확대하는 것을 목표로 하고 있습니다. 이를 통해 신흥 항공우주 분야에서 더욱 전문화된 과정을 개발 할 수 있고, 글로벌 항공우주 기관과의 파트너십을 강화하도록 노력하겠습니다. 또한, 컨텐츠와 프로그램의 접근성을 높이기 위해 온라인 플랫폼으로 확장하고자 하고 지속적으로 혁신하고 범위를 확장 함으로써 저희는 차세대 항공우주의 발전을 함께 하고자 합니다.
            </p>

          </div>
        )}
        {language === 'en' && (
          <div
            id="single-entry-content"
            className="prose dark:prose-invert prose-sm !max-w-screen-md sm:prose lg:prose-lg mx-auto dark:prose-dark"
          >
            <h3>
              <p>
                Theories and Hands-On Projects: Building Cube Satellites
              </p>
            </h3>
            <p>
              One of our flagship programs focuses on empowering students and professionals to design, build, and test CubeSat satellites. We had in-house R&D for low cost satellites and we are using these innovations for our programs. This program integrates theoretical foundations with practical applications, guiding participants through:
            </p>
            <ol>
              <li>Orbital mechanics and satellite design principles.</li>
              <li>
                Developing and assembling CubeSat hardware components.
              </li>
              <li>
                Integrating payloads and conducting simulation tests.
              </li>
              <li>
                Launch preparation and post-launch analysis.
              </li>
            </ol>
            <p>
              Participants gain invaluable experience in project management, teamwork, and problem-solving while working with industry grade tools and equipments. This program has been particularly impactful for undergraduate engineering students and military personnel seeking specialized technical expertise.
            </p>

            <h3>Satellite Image Processing: LRIT Technology</h3>
            <p>
              Another core offering is our specialized workshop on processing Low Rate Information Transmission (LRIT) images. Participants delve into:
            </p>
            <ol>
              <li>
                Fundamentals of satellite communication systems.
              </li>
              <li>
                Basic C++
              </li>
              <li>
                Techniques to decode, decrypt and analyze LRIT image data.
              </li>
              <li>
                Error handling of LRIT data
              </li>
              <li>
                And finally visualizing into an image!
              </li>
            </ol>
            <p>This program equips students with advanced data analysis skills, essential for careers in satellite technology, meteorology, and geospatial sciences. Students will be learning from the professionals from the aerospace industry, such as KARI (link). Tertiary students and educators have found this workshop particularly valuable in enriching their curricula.
            </p>
            <blockquote>
              <p>
                우주 산업에 꿈을 그려온 우리가 프로그램을 통해 꿈을 향해 나아가고 발전할 수 있었던 기회
                출처 : 제주의소리(http://www.jejusori.net)
              </p>
            </blockquote>
            <figure>
              <img
                src="https://i.pinimg.com/736x/12/9d/4f/129d4f77185d727a722b5f895ead2743.jpg"
                alt="nc blog"
                className="rounded-2xl"
              />
              <figcaption>
                -
              </figcaption>
            </figure>
            <h3>
              <p>
                Theories and Hands-On Projects: Building Cube Satellites
              </p>
            </h3>
            <p>
              One of our flagship programs focuses on empowering students and professionals to design, build, and test CubeSat satellites. We had in-house R&D for low cost satellites and we are using these innovations for our programs. This program integrates theoretical foundations with practical applications, guiding participants through:
            </p>
            <ol>
              <li>Orbital mechanics and satellite design principles.</li>
              <li>
                Developing and assembling CubeSat hardware components.
              </li>
              <li>
                Integrating payloads and conducting simulation tests.
              </li>
              <li>
                Launch preparation and post-launch analysis.
              </li>
            </ol>
            <p>
              Participants gain invaluable experience in project management, teamwork, and problem-solving while working with industry grade tools and equipments. This program has been particularly impactful for undergraduate engineering students and military personnel seeking specialized technical expertise.
            </p>

            <h3>Aerospace Engineering Theories for Undergraduates</h3>
            <p>
              For mechanical engineering undergraduates with hopes to enhance their knowledge with aerospace engineering , we offer comprehensive courses covering:
            </p>
            <ol>
              <li>
                Aerodynamics, engines and propulsion systems.
              </li>
              <li>
                Structural analysis and materials for aerospace applications.
              </li>
              <li>
                Knowledge into the space environments and test planning
              </li>
            </ol>
            <p>
              These courses bridge the gap between mechanical engineering fundamentals and specialized aerospace concepts, preparing students for further studies or careers in the aerospace sector. Delivered by seasoned aerospace professionals, the program ensures theoretical depth coupled with real-world relevance.
            </p>

            <h3>High School Aerospace Curriculum</h3>
            <p>
              Our semester-long high school curriculum introduces students to the exciting world of aerospace engineering and sciences. The program includes:
            </p>
            <ol>
              <li>
                Basics of aerodynamics and space exploration.
              </li>
              <li>
                Design and construction of model rockets and gliders.
              </li>
              <li>
                Knowledge into the space environments and test planning
              </li>
              <li>
                Guidances to physical setup of space-related labs within the school compounds
              </li>
            </ol>
            <p>
              NaroSTP has been actively working with Hanlim Engineering High School in Jeju to develop Korea’s first aerospace engineering curriculum for the high school students. Our proposed curriculum is not just theoretical but also highly hands-on to inspire and challenge high school students.Through this curriculum, we hope students to foster creativity, critical thinking, and a passion for STEM. We are working with Jeju local government and the Korean Ministry of Education for this journey.
            </p>

            <h3>Upskilling Programs for Educators</h3>
            <p>
              To ensure the ripple effect of knowledge, we are also offering upskilling programs tailored for current tertiary educators and teachers. These programs include:
            </p>
            <ol>
              <li>
                Training in the latest aerospace technologies and teaching methodologies.
              </li>
              <li>
                Guidance on incorporating aerospace content into existing curricula.
              </li>
              <li>
                Hands-on workshops to enhance instructional skills.
              </li>
              <li>
                Field trips to the aerospace companies and institutions such as Kennedy Space Visitor Center in Florida, US and Johnson Space Center in Huston, US.
              </li>
            </ol>
            <p>
              Our upskilling initiatives are designed to empower educators and teachers with the tools, fine-tuned knowledge and confidence to guide and inspire their students effectively. Through the partnership with the education sector, we amplify the reach and impact of aerospace education. We are closely working with industry players such as KARI, Kennedy Space Visitor Center and Johnson Space Center for this effort.
            </p>

            <h3>Sparking Interest in Young Children</h3>
            <p>
              For the youngest minds, we conduct fun activities to ignite their curiosity about aerospace. We know that they just want to have fun! Programs include:
            </p>
            <ol>
              <li>
                Interactive storytelling about the universe and space exploration.
              </li>
              <li>
                Simple experiments and craft projects, such as building paper rockets and even our cube satellites!
              </li>
              <li>
                Field trips to the aerospace companies and institutions such as Kennedy Space Visitor Center in Florida, US and Johnson Space Center in Huston, US.
              </li>
            </ol>
            <p>
              Through conducting fun and educational activities, we aim to lay the foundation for a lifelong interest in science, technology, engineering, and mathematics fields (STEM). This will be their great first step into the field of aerospace.
            </p>

            <h3>Field Trips to Aerospace Industries</h3>
            <p>
              Nothing inspires like real-world exposure. We organize local and overseas field trips to leading aerospace facilities, offering participants a firsthand look at the industry in action. Highlights include:
            </p>
            <ol>
              <li>
                Visits to the Kennedy Space Center and Johnson Space Center in the United States.
              </li>
              <li>
                Tours of aerospace manufacturing and research facilities in Korea.
              </li>
              <li>
                Q&A sessions with aerospace engineers, scientists, industry leaders and even the astronauts!
              </li>
            </ol>
            <p>
              These field trips provide unique and unparalleled learning opportunities, allowing participants and students to connect theoretical knowledge with practical applications and industry trends.
            </p>

            <h3>Diverse Target Audiences</h3>
            <p>
              Our programs are tailored to meet the needs of various groups, including:
            </p>
            <ol>
              <li>
                <strong>Undergraduates: </strong>Hands-on projects and theoretical courses provide a strong foundation for aspiring aerospace professionals.
              </li>
              <li>
                <strong>Tertiary Educators:</strong> Upskilling workshops and curriculum equip educators with the latest tools and knowledge to inspire their students.
              </li>
              <li>
                <strong>High School Students:</strong> Comprehensive curricula introduce the exciting world of aerospace, fostering interest and skills in STEM.
              </li>
              <li>
                <strong>Military Personnel:</strong> Specialized training programs enhance technical skills relevant to defense applications.
              </li>
              <li>
                <strong>Young Children and the General Public:</strong> Fun, interactive activities spark curiosity and promote awareness about aerospace.
              </li>
            </ol>
            <p>
              These field trips provide unique and unparalleled learning opportunities, allowing participants and students to connect theoretical knowledge with practical applications and industry trends.
            </p>

            <h3>Expertise and Partnerships</h3>
            <p>
              Our programs are led by current and retired professionals from the aerospace industry, providing exposures and opportunities to participants to receive guidance from experts with extensive practical knowledge, know-hows and experience. Furthermore, our strong partnerships with institutions such as KARI, the Kennedy Space Center and Johnson Space Center augment our initiatives to provide unique opportunities to our participants and students which range from workshops, lessons to visits and collaborative projects. We are also working closely with the local governments, Korea MInistry of Education and schools to lay an aerospace learning journey for all.
            </p>

            <h3>Future Roadmap</h3>
            <p>
              Looking ahead, we aim to expand our collaborations with educational institutions, government agencies, and industry leaders. Our roadmap includes:
            </p>
            <ol>
              <li>
                Developing more specialized courses in emerging aerospace fields.
              </li>
              <li>
                Strengthening partnerships with global aerospace organizations.
              </li>
              <li>
                Expansion into online platforms for greater accessibility to our contents and programs.
              </li>
            </ol>
            <p>
              By continuously innovating and expanding our reach, we aspire to inspire and educate the next generation of aerospace pioneers.
            </p>

            <p>
              Our aerospace education programs reflect our commitment to nurturing curiosity, developing skills, and inspiring the future of exploration and innovation. Whether through hands-on workshops, advanced theoretical courses, or unforgettable field trips, we strive to make the wonders of aerospace accessible to everyone.
            </p>
          </div>
        )}      </>
    );
  };

  const renderTags = () => {
    return (
      <div className="max-w-screen-md mx-auto flex flex-wrap">
        <a
          className="nc-Tag inline-block bg-white text-sm text-neutral-600 dark:text-neutral-300 py-2 rounded-lg border border-neutral-100  md:px-4 dark:bg-neutral-700 dark:border-neutral-700 hover:border-neutral-200 dark:hover:border-neutral-6000 mr-2 mb-2"
          href="##"
        >
          Garden
        </a>
        <a
          className="nc-Tag inline-block bg-white text-sm text-neutral-600 dark:text-neutral-300 py-2 rounded-lg border border-neutral-100  md:px-4 dark:bg-neutral-700 dark:border-neutral-700 hover:border-neutral-200 dark:hover:border-neutral-6000 mr-2 mb-2"
          href="##"
        >
          Jewelry
        </a>
        <a
          className="nc-Tag inline-block bg-white text-sm text-neutral-600 dark:text-neutral-300 py-2 rounded-lg border border-neutral-100  md:px-4 dark:bg-neutral-700 dark:border-neutral-700 hover:border-neutral-200 dark:hover:border-neutral-6000 mr-2 mb-2"
          href="##"
        >
          Tools
        </a>
      </div>
    );
  };

  const renderAuthor = () => {
    return (
      <div className="max-w-screen-md mx-auto ">
        <div className="nc-SingleAuthor flex">
          <Avatar sizeClass="w-11 h-11 md:w-24 md:h-24" />
          <div className="flex flex-col ml-3 max-w-lg sm:ml-5 space-y-1">
            <span className="text-xs text-neutral-400 uppercase tracking-wider">
              WRITEN BY
            </span>
            <h2 className="text-lg font-semibold text-neutral-900 dark:text-neutral-200">
              <a href="/">Fones Mimi</a>
            </h2>
            <span className="text-sm text-neutral-500 sm:text-base dark:text-neutral-300">
              There’s no stopping the tech giant. Apple now opens its 100th
              store in China.There’s no stopping the tech giant.
              <a className="text-primary-6000 font-medium ml-1" href="/">
                Readmore
              </a>
            </span>
          </div>
        </div>
      </div>
    );
  };

  const renderCommentForm = () => {
    return (
      <div className="max-w-screen-md mx-auto pt-5">
        <h3 className="text-xl font-semibold text-neutral-800 dark:text-neutral-200">
          Responses (14)
        </h3>
        <form className="nc-SingleCommentForm mt-5">
          <Textarea />
          <div className="mt-2 space-x-3">
            <ButtonPrimary>Submit</ButtonPrimary>
            <ButtonSecondary>Cancel</ButtonSecondary>
          </div>
        </form>
      </div>
    );
  };

  const renderCommentLists = () => {
    return (
      <div className="max-w-screen-md mx-auto">
        <ul className="nc-SingleCommentLists space-y-5">
          <li>
            <Comment />
            <ul className="pl-4 mt-5 space-y-5 md:pl-11">
              <li>
                <Comment isSmall />
              </li>
            </ul>
          </li>
          <li>
            <Comment />
            <ul className="pl-4 mt-5 space-y-5 md:pl-11">
              <li>
                <Comment isSmall />
              </li>
            </ul>
          </li>
        </ul>
      </div>
    );
  };

  const renderPostRelated = (post: PostDataType) => {
    return (
      <div
        key={post.id}
        className="relative aspect-w-3 aspect-h-4 rounded-3xl overflow-hidden group"
      >
        <Link to={post.href} />
        <NcImage
          className="object-cover w-full h-full transform group-hover:scale-105 transition-transform duration-300"
          src={post.featuredImage}
        />
        <div>
          <div className="absolute bottom-0 inset-x-0 h-1/2 bg-gradient-to-t from-black"></div>
        </div>
        <div className="flex flex-col justify-end items-start text-xs text-neutral-300 space-y-2.5 p-4">
          <Badge name="Categories" />
          <h2 className="block text-lg font-semibold text-white ">
            <span className="line-clamp-2">{post.title}</span>
          </h2>

          <div className="flex">
            <span className="block text-neutral-200 hover:text-white font-medium truncate">
              {post.author.displayName}
            </span>
            <span className="mx-1.5 font-medium">·</span>
            <span className="font-normal truncate">{post.date}</span>
          </div>
        </div>
        <Link to={post.href} />
      </div>
    );
  };

  return (
    <div className="nc-PageSingle pt-8 lg:pt-16 ">
      <Helmet>
        <title>항공우주교육</title>
      </Helmet>
      {renderHeader()}
      <NcImage
        className="w-full rounded-xl"
        containerClassName="container my-10 sm:my-12 "
        src="https://i.pinimg.com/736x/33/d8/4e/33d84ed27af7abf272461aabe21790f6.jpg"
      />

      <div className="nc-SingleContent container space-y-10">
        {renderContent()}
        {/* {renderTags()} */}
        <div className="max-w-screen-md mx-auto border-b border-t border-neutral-100 dark:border-neutral-700"></div>
        {/* {renderAuthor()}
        {renderCommentForm()}
        {renderCommentLists()} */}
      </div>
      {/* <div className="relative bg-neutral-100 dark:bg-neutral-800 py-16 lg:py-28 mt-16 lg:mt-24">
        <div className="container ">
          <h2 className="text-3xl font-semibold">Related posts</h2>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
            {DEMO_POSTS.filter((_, i) => i < 4).map(renderPostRelated)}
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default BlogSingle;
